import { prepareQueryParams } from 'utils/prepareQueryParams';

import initialApiService from 'services/initialApiService';

import {
  GetProfilesPropsType,
  GetProfilesResponseType,
  VerifyProfilePropsType,
  VerifyProfileResponseType,
} from './moderationApiService.types';

import { createProfileUrl } from './utils';

const moderationApiService = initialApiService.injectEndpoints({
  endpoints: (builder) => ({
    getProfiles: builder.query<GetProfilesResponseType, GetProfilesPropsType>({
      query: (params: GetProfilesPropsType) => ({
        url: createProfileUrl(`/moderation/profile${prepareQueryParams(params)}`),
      }),
      providesTags: [],
    }),
    verifyProfile: builder.mutation<VerifyProfileResponseType, VerifyProfilePropsType>({
      query: (params: VerifyProfilePropsType) => ({
        url: createProfileUrl(`/moderation/profile/verification${prepareQueryParams(params)}`),
        method: 'POST',
        responseHandler: 'text',
      }),
    }),
  }),
});

export const { useGetProfilesQuery, useVerifyProfileMutation } = moderationApiService;
export default moderationApiService;
